import { Config } from "../config";
import { Service } from ".";

export const DocumentService = {
    /**
    * [LIST]
    */
    List() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return DocumentService.Common.Fetch(Config.service.document.list, requestOptions);

    },
    /**
    * [DETAIL]
    * @param {string} login
    */
    Detail(data) {

        var requestOptions = {
            method: 'POST',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return DocumentService.Common.Fetch(Config.service.document.detail, requestOptions);

    },
      /**
    * [ACTION]
    * @param {string} login
    * @param {string} approve
    */
   Action(data) {

    var requestOptions = {
        method: 'POST',
        headers: Config.utilities.authorizedHeader(),
        body: JSON.stringify(data)
    }

    return DocumentService.Common.Fetch(Config.service.document.action, requestOptions);

},
    /**
 * [COMMON]
 * @function Fetch
 */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {
                        Service.User.Logout();
                        window.location.reload();

                    } else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}